import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.deletePOCustomField.presenters.useDeletePOCustomFieldPresenter`

export default defineMessages({
  confirmationModalTitle: {
    id: `${scope}.confirmationModalTitle`,
    defaultMessage: 'Delete custom field',
  },
  confirmationModalDescription: {
    id: `${scope}.confirmationModalDescription`,
    defaultMessage:
      'Would you like to delete the custom field {name}? This action cannot be undone.',
  },
  confirmationModalConfirmButton: {
    id: `${scope}.confirmationModalConfirmButton`,
    defaultMessage: 'Confirm',
  },
  confirmationModalCancelButton: {
    id: `${scope}.confirmationModalCancelButton`,
    defaultMessage: 'Cancel',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Field has been deleted.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to delete the custom field.',
  },
})
